import { gql } from '@apollo/client';

export default gql`
  fragment FeatureSetDetails on FeatureSet {
    video
    integrations
    videoOptionsVisible
    projectCollaboration
    reportGeneration
    beforeAfterPhotos
    galleryLinks
    reportTextSnippets
    taskLists
    todosMarketplace
    logoStickers
    reportTemplates
    templates
    documentSigning
    trusty
    payments
    companyDashboard
    checklistAssignment
    ultraResImages
    videoWalkthroughs
    showcases
  }
`;
